// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"88":"df55b752334be01e7e4d","195":"fb0504e177b2f58754b9","243":"307c1cf31df043fbcfea","498":"bd166707ac7b88d2e2b6","556":"77bb490ba869d50a6912","595":"f7776ac79a7da92f941a"}[chunkId] + ".bundle.js";
};